import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import ActionLink from './ActionLink';

const BreadcrumbsNav = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const sections = props?.sections || [];
	if(sections.length === 0) return null;

	const is_floating = props?.floating ?? false;
	const current = props?.current ?? 0;

	return (
		<aside class={`gui_breadcrumbs${(is_floating) ? ' floating_nav' : ''}`}>
			<nav class="contents">
				{sections.map((section, i) => {
					const is_actual = (current === i) ? true : false;
					const is_previous = (current > i) ? true : false;

					let classname = [];
					if(is_actual) classname.push("selected");
					if(is_previous) classname.push("previous");

					return (
						<span class={classname.join(" ")} key={i}>
							<span class="breadcrumb_index">{i+1}.</span>

							{(is_previous && section.link != undefined && section.link) ? (
								<ActionLink _href={section.link} _target="_self">{section.label}</ActionLink>
							) : (
								<span>{i18n(section.label)}</span>
							)}
						</span>
					)
				})}
			</nav>
		</aside>
	)
}

export default injectIntl(BreadcrumbsNav);